export const COMPANION_AD_CLICKED = 'companion.ad.clicked';
export const COMPANION_INVALID_CLICK_HANDLER = 'companion.ad.click.handler.error';
export const COMPANION_AD_RENDER_ERROR = 'companion.ad.render.error';
export const IMA_PLAYER_AD_ERROR = 'ima.player.ad.error';
export const IMA_PLAYER_AD_COMPANION_ERROR = 'ima.player.ad.companion.error';
export const IMA_PLAYER_AD_REQUEST_REPORTING_ERROR = 'ima.player.ad.request.reporting.error';
export const IMA_PLAYER_ERROR = 'ima.player.error';
export const IMA_PLAYER_AUTOPLAY_ERROR = 'ima.player.autoplay.error';
export const INSTREAM_AD_COMPANION_ERROR = 'instream.ad.companion.error';
export const INSTREAM_COMPANION_AD_CLICKED = 'instream.companion.ad.clicked';
export const FALLBACK_API_USED = 'fallback.api.used';
export const FALLBACK_CONFIG_USED = 'fallback.config.used';
export const PAL_NONCE_GENERATOR_ERROR = 'google.pal.nonce.generator.error';
export const PAL_REPORTING_ERROR = 'google.pal.reporting.error';
export const LOTAME_FETCH_AUDIENCE_ERROR = 'lotame.fetch.audience.error';
export const LOTAME_COMMAND_QUEUE_ERROR = 'lotame.command.queue.error';
export const APS_BIDS_FETCH_ERROR = 'aps.bids.fetch.error';
